import React from 'react'
import { format } from 'date-fns'
import { IMarkerInfo, MarketTYPE } from '@/pages/dashboard/DashboardMapDefault.tsx'
import { AlertStatus } from '@/api/user/getUsers.ts'
import { useTranslation } from 'react-i18next'
import { IUserBbox } from '@/api/user/getUsersBbox.ts'
import { Link } from 'react-router-dom'
import { isSkVariant } from '@/util/isSkVariant.ts'

interface IProps {
    info?: IMarkerInfo<IUserBbox>
    isMasking?: boolean
}

const MarkerWindow: React.FunctionComponent<IProps> = ({ info, isMasking = false }) => {
    const { t } = useTranslation()
    const skVariant = isSkVariant()

    // 마스킹 처리 함수
    const getMaskedName = (name?: string) => {
        if (!isMasking || !name) return name
        if (name.length <= 1) return name
        return name.charAt(0) + '**'
    }

    const deviceStatusClassName = (status?: AlertStatus) => {
        switch (status) {
            case AlertStatus.EMERGENCY:
                return 'border-sub_r hover:bg-sub_r hover:text-white'
            case AlertStatus.BIO:
                return 'border-[#FF7D33] hover:bg-[#FF7D33] hover:text-white'
            default:
                return 'border-main_b hover:bg-main_b hover:text-white'
        }
    }
    return (
        <>
            <div className="px-[12px] py-[10px] max-w-[259px]">
                <p className={'text-[12px] leading-[22px]'}>
                    {info?.users?.map((user) => {
                        const badgeClassName = `px-[4px] min-h-[21px] border border-solid rounded-[5px] mr-[5px] whitespace-nowrap ${deviceStatusClassName(user?.todayAlert)}`
                        if (skVariant) {
                            return (
                                <span key={`${user?.id}`} className={badgeClassName}>
                                    {getMaskedName(user?.name)}
                                </span>
                            )
                        }
                        return (
                            <Link key={`${user?.id}`} to={`/user?id=${user?.id}`}>
                                <span className={`${badgeClassName} cursor-pointer`}>
                                    {getMaskedName(user?.name)}
                                </span>
                            </Link>
                        )
                    })}
                </p>
                {info?.locationName && (
                    <p className="font-bold text-[14px] mt-[5px]">{info?.locationName}</p>
                )}
                <p className="text-[12px] font-medium mt-[5px]">
                    {isMasking ? '****' : info?.address}
                </p>
                {info?.location?.timestamp && info?.type == MarketTYPE.SINGLE && (
                    <p className="text-[12px] text-gray4 mt-[5px]">
                        {t('dashboard.marker.window.recent', {
                            datetime: format(info?.location?.timestamp || 0, 'yyyy-MM-dd HH:mm')
                        })}
                    </p>
                )}
            </div>
        </>
    )
}

export default MarkerWindow
